import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import EditCategoryView from '../components/EditCategoryView'
import { currentUser, getDraftItem } from '../../reducer';

import { editItemCategoryId, editItemCategoryName, setChangingCategory, syncItemProps } from '../actions'

const mapStateToProps = (state) => {

  let account_subdomain = '';
  const account = currentUser(state).get("account");
  if (account !== undefined){
    account_subdomain = account.subdomain;
  }

  return {
    apiVars: {
      api_token: currentUser(state).get("api_token"),
      venue_permalink: getDraftItem(state).get("venue_permalink"),
      account_subdomain: account_subdomain
    }
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleClick: ({api_token,venue_permalink,account_subdomain}) => {
      dispatch(editItemCategoryId(ownProps.item_id,ownProps.id));
      dispatch(editItemCategoryName(ownProps.item_id,ownProps.name));
      dispatch(setChangingCategory(false))

      //sync to server
      dispatch(syncItemProps(api_token,venue_permalink,account_subdomain,ownProps.item_id,{category_id:ownProps.id, name: ownProps.name}))

    }
  }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    handleClick: () => dispatchProps.handleClick(stateProps.apiVars)
  })
}

export const EditCategory = connect(mapStateToProps,mapDispatchToProps, mergeProps)(EditCategoryView);

export default EditCategory;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/EditCategory.js